<script>
  import Button from '@components/button.svelte'
  import BooleanControl from '@components/boolean-control.svelte'
  import searchState from '@state/global-search-state.svelte.js'
  import { X } from 'lucide-svelte'
</script>

<!-- The settings container -->
<div class="flex flex-col h-full">

<!-- A flex column -->
<div class="flex flex-col items-center justify-start gap-4 p-8 flex-1">

  <!-- Settings header -->
  <div class="flex items-center justify-center w-full relative mb-6">
    <h5 class="text-base font-semibold text-gray-700">Paramètres de la recherche globale</h5>
    <Button naked onclick={() => searchState.settingsOpen = false} class="text-gray-400 hover:text-gray-600 absolute right-0">
      <X size={16} />
    </Button>
  </div>

  <!-- The list of options -->
  <div class="flex flex-col gap-0 w-full">

    <div class="flex items-center justify-between gap-2 px-3 py-2 border-b border-gray-200">
      <span class="text-gray-500">Surligner les correspondances</span>
      <BooleanControl bind:value={searchState.highlight} />
    </div>

    <div class="flex items-center justify-between gap-2 px-3 py-2 border-b border-gray-200">
      <span class="text-gray-500">Filter les résultats par clinique</span>
      <BooleanControl bind:value={searchState.globalScope} />
    </div>

    <div class="flex items-center justify-between gap-2 px-3 py-2 border-b border-gray-200">
      <span class="text-gray-500">Plein écran</span>
      <BooleanControl bind:value={searchState.fullScreen} />
    </div>

    <div class="flex items-center justify-between gap-2 px-3 py-2">
      <span class="text-gray-500">Mode Algolia</span>
      <BooleanControl bind:value={searchState.algoliaOnly} />
    </div>

  </div>

</div>

<!-- The settings footer -->
<div class="flex w-full items-center justify-end px-5 py-4 bg-stone-100/60 rounded-b-xl border-t border-stone-200/80">

  <Button naked class="flex items-center gap-1 hover:*:text-gray-800" onclick={() => searchState.settingsOpen = false}>
    <X size={26} strokeWidth={2.5} class="border border-stone-200 bg-stone-50 text-stone-400 p-1" />
    <span class="text-[14px] tracking-wide text-stone-400 ml-2">Fermer</span>
  </Button>

</div>

</div>
